/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Grid, IconButton, InputAdornment } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ReadOnlyTextFieldView } from '../../../../shared/views/ReadOnlyTextField.view';

interface Props {
	flagPost?: {
		id?: string;
		newsItem?: {
			url?: string;
		};
		happening?: {
			url?: string;
		};
	};
}

class FlaggedContentDetailsUrlView extends React.Component<Props> {
	render(): JSX.Element | null {
		const { flagPost } = this.props;
		const url = flagPost?.newsItem?.url || flagPost?.happening?.url;
		const postAppUrl = process.env.REACT_APP_POST_APP_URL;
		const postUrl = postAppUrl && flagPost?.id ? `${postAppUrl}/post-detail?id=${flagPost.id}` : undefined;

		if (!url && !postUrl) {
			return null;
		}

		return (
			<>
				{url && (
					<Grid item xs={12}>
						<ReadOnlyTextFieldView
							id="url"
							name="url"
							label="URL"
							value={url}
							InputProps={{ readOnly: true }}
							InputLabelProps={{
								shrink: true
							}}
							fullWidth
						/>
					</Grid>
				)}
				{postUrl && (
					<Grid item xs={12}>
						<ReadOnlyTextFieldView
							id="postUrl"
							name="postUrl"
							label="Post URL"
							value={postUrl}
							InputProps={{
								readOnly: true,
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="Open post in new tab"
											href={postUrl}
											target="_blank"
											rel="noopener noreferrer"
											size="small"
										>
											<OpenInNewIcon fontSize="small" />
										</IconButton>
									</InputAdornment>
								)
							}}
							InputLabelProps={{
								shrink: true
							}}
							fullWidth
						/>
					</Grid>
				)}
			</>
		);
	}
}

export default FlaggedContentDetailsUrlView;
